/*
angelCake v3.0 (http://angelcake.executiveresults.ca)
Copyright 2018 Executive Results
Licensed under the MIT license
*/

head.ready("appJS", function() {
  $(document).ready(function() {
  	$('ac-alert').on('click',function(){
  		$(this).slideUp();
  	});
  });
 });